var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.user_uid
      ? _c("div", [
          _vm.id_asta
            ? _c("div", [_c("Main")], 1)
            : _c("div", [
                _c(
                  "div",
                  { staticClass: "view" },
                  [
                    _c("v-card", { attrs: { width: "300" } }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "px-8 py-5 d-flex flex-column align-center",
                        },
                        [
                          _c("img", {
                            staticClass: "logo",
                            attrs: {
                              src:
                                _vm.firebase_host +
                                "/static/img/logo_ombra.png",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
        ])
      : _c("div", [_c("LoginRouter")], 1),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }